import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from 'store/ducks';
import { getChatOrderEligibility } from 'apis/CommerceGraphql/chatOrder';
import {
  setChatOrderEligibility,
} from 'store/ducks/chatOrderStore';

export const useChatOrderEligibility = (baId: string | number | null) => {
  const dispatch = useDispatch();
  const { eligibility } = useSelector((state: StoreState) => ({
    eligibility: baId ? state.chatOrderStore.chatOrderEligibility[String(baId)] : null,
  }));

  const fetchEligibility = useCallback(async () => {
    const result = await getChatOrderEligibility(String(baId));
    dispatch(
      setChatOrderEligibility({
        baId: String(baId),
        eligibility: result,
      })
    );
    return result;
  }, [baId, dispatch]);

  useEffect(() => {
    if (!baId || eligibility) return;
    fetchEligibility();
  }, [baId, eligibility, dispatch,fetchEligibility]);

  return {
    eligibility,
    refetch:fetchEligibility,
  };
};
